<template>
  <section class="library-main-content filters-content" v-if="collectionEntries" @click="toggleOpenOptions(null)">
      <div class="filter-results">
          <span class="title">
              {{$t('SEARCH_RESULT')}}:
          </span>
          <span class="result">
              {{searchWord}}
          </span>
          <span class="cancel" @click="returnToBaseLibrary">
            <img src="@/assets/images/clear_search.svg" alt="x">
          </span>
          <pagination-options  v-if="collectionEntries.length>maxNumOfResults"
               :openOptions="openOptions=='start'"  @toggleOpenOptions="toggleOpenOptions('start')"
               :startIndex="startIndex+1" :numOfResult="collectionEntries.length"
               :endIndex="endIndex" :selectedCount="selectedCount"
               @goNext="goNext" @goPrev="goPrev" @changeSelectedCount="changeSelectedCount"
          />
      </div>
      <section class="library-result-list">
        <template v-if="collectionEntries.length">
          <div v-for="entry in collectionEntries.slice(startIndex, endIndex)" :key="entry.data.id">
            <entry-row :collectionEntry="entry"/>
          </div>
        </template>
        <template v-else>
          {{$t('NO_RESULTS_EXIST')}}
        </template>
      </section>
      <div class="pages-bottom" v-if="collectionEntries.length>maxNumOfResults">
        <pagination-options
            :openOptions="openOptions=='end'"
            @toggleOpenOptions="toggleOpenOptions('end')"
            :startIndex="startIndex+1"
            :numOfResult="collectionEntries.length"
            :endIndex="endIndex"
            :selectedCount="selectedCount"
            @goNext="goNext" @goPrev="goPrev"
            @changeSelectedCount="changeSelectedCount"
        />
      </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import PaginationOptions from '@/components/pagination-options'
import { maxNumOfResults, paginationOptions } from '@/constants'
import { toggleOpenOptions, goPrev, goNext, changeSelectedCount } from '@/paginationFunctions'
import EntryRow from '@/components/entry-row'

export default {
  name: 'search-results',
  components: { EntryRow, PaginationOptions },
  data () {
    return {
      // if `openOption` = `start`, the 'pagination-options' in the start of page is open
      // if `openOption` = `end`, the 'pagination-options' in the end of page is open
      // if `openOption` = null, the both of the options is closed
      openOptions: null,
      startIndex: 0,
      selectedCount: paginationOptions[0],
      maxNumOfResults
    }
  },
  computed: {
    ...mapState({
      searchWord: state => state.collections.searchWord,
      collectionEntries: state => state.collections.collectionEntries
    }),
    endIndex () {
      const index = this.startIndex + this.selectedCount
      if (index > this.collectionEntries.length) {
        return this.collectionEntries.length
      } else {
        return index
      }
    }
  },
  methods: {
    toggleOpenOptions,
    goNext,
    goPrev,
    changeSelectedCount,
    returnToBaseLibrary () {
      this.$store.dispatch('setSearchWord', null)
      this.$store.dispatch('getLibraryRootCollections').then(() => {
        this.$router.push({ name: 'baseLibrary', query: { filters: this.$route.query.filters } })
      })
    }
  }
}
</script>

<style scoped>

</style>
